/**
 * 视频路演 东财im
 */
import roadshow_im from './roadshow_im'
import user from '../user'
import moment from 'moment'
import _ from 'lodash'

let thisuser = user.get()
let newtime:any = undefined

/**
 * 展示时间
 * @param SendDateTime 发送时间
 * @param preSendDateTime 上一条的发送时间
 */
function getShowTime(SendDateTime:number, preSendDateTime:number|undefined){
  var thistime = moment(SendDateTime * 1000)
  var sameBlock = false //是否和上一条同在一个块

  if(preSendDateTime != undefined){
      var pretime = moment(preSendDateTime * 1000)
      sameBlock = thistime.isSameOrBefore(pretime.add(5,'minute')) //5分钟间隔不重复显示
  }
  if(sameBlock){
      return ''
  }

  /**
   * 是否是同一天
   */
  var issameyear = moment().isSame(thistime,'year')
  var issameday = moment().isSame(thistime, 'day')
   
  if (issameyear){
    if (issameday) {
      return thistime.format("HH:mm");
    }
    else {
      return thistime.format("MM月DD日 HH:mm");
    }
  }else{
    return thistime.format("YYYY年MM月DD日 HH:mm");
  }
        
}

/**
 * 处理单条消息
 * @param message 
 */
function dealOneMessage(v:any) {

  
  //处理object
  if(typeof v.Content == 'string'){
    try {
        v.Content = JSON.parse(v.Content)
    } catch (error) {
      v.Content = {
        txt: v.Content
      }
    }
  }


  try {
    if(v.QuoteMessage && v.QuoteMessage.Content){
      v.QuoteMessage.Content = JSON.parse(v.QuoteMessage.Content)
    }     
  } catch (error) {
    
  }



  //#region 处理type
  v.type = 'normal'
  //私信
  if(v.Content.receiver != undefined){
    if(thisuser != null && v.Content.receiver && v.Content.receiver.emuid == thisuser.id){
      v.type = 'private' //我的私信
    }
    else{
      v.type = 'nomyprivate' //不是我的私信
    }
  }
  //回复
  else if(v.QuoteMessage != undefined){
    v.type = 'reply'
  }
  //#endregion

  //#region 处理isSelf
  v.isSelf = false
  if(thisuser != null){
    v.isSelf = v.Sender.UserID == thisuser.id
  }
  //#endregion

  //#region 处理showtime
  v.showtime = getShowTime(v.SendDateTime, newtime)
  newtime = v.SendDateTime
  //#endregion
    

}

export default {
  dealOneMessage: dealOneMessage,
  /**
   * 获取历史聊天记录
   */
  async getMessageList(){
    return new Promise((resolve, reject)=>{
      roadshow_im.getList(function(data: any){     
        if (!data){
          resolve([]);
          return 
        };

        //if(data.result == 1){
          let backlist = data.map((v:any)=>{      
            let ContentObj = JSON.parse(v.Content)
            return ContentObj
          })

          backlist.forEach((v:any)=>{
            dealOneMessage(v)
          })

          backlist = backlist.filter((v:any)=>{
            return v.type != 'nomyprivate'
          })
          resolve(backlist)
        //}
        //else{
        //  reject(new Error('获取聊天历史列表失败'))
        //}
      })      
    })
  },

  /**
   *  根据条件查询历史
   * @returns
   */
  async getChannelMessagesForPri(params:{
    // pageIndex:number,
    // pageSize:number,
    // orderby:number,
    // beginTime:string,
    // endTime:string
  }){
    return new Promise((resolve, reject) => {
      roadshow_im.getHistoryListForPri(params,function (data: any) {
        try {
          if (!data) {
            resolve([]);
            return
          };

          let list = data || [];

          let backlist = list.map((v: any) => {
            v.Content = JSON.parse(v.Content);
            v.sendtime = v.SendDateTime;
            v.SendDateTime = (moment(v.SendDateTime).valueOf().toString()).substr(0, 10);

            let Senderobj = {
              Nick: v.SenderNickName,
              UserID: v.Sender
            }
            v.Sender = Senderobj

            if (v?.QuoteMessage) {
              let quotecontent = JSON.parse(v?.QuoteMessage?.Content);
              let QuoteMessage = {
                Sender: {
                  Nick: v?.QuoteMessage?.SenderNickName
                },
                Content: {
                  txt: quotecontent.txt
                }
              }

              v.QuoteMessage = QuoteMessage
            }

            return v
          })

          backlist.forEach((v: any) => {
            dealOneMessage(v)
          })

          backlist = backlist.filter((v: any) => {
            return v.type != 'nomyprivate'
          })

          resolve(backlist)
        } catch (error) {
          resolve([]);
        }

      })
    })
  },

  /**
   * 注册事件：有新消息来了
   * @param callback 
   */
  regGetNewMessage(callback:any){
    roadshow_im.regGetNewMessage(function(data:any){
      dealOneMessage(data)
      callback(data)
    })
  },

  /**
   * 发布新消息
   * @param newmessage 
   */
  async sendNewMessage(newmessage:string){
    return roadshow_im.sendNewMessage(newmessage)
  },

   async sendNewQuoteMessage(newmessage:string, quotemessage:any){
    return roadshow_im.sendNewQuoteMessage(newmessage, quotemessage)
  }, 

  /**
   * 被禁言
   * @param callback 
   */
  onForbidden: function(callback: () => void){
      roadshow_im.onForbidden(callback)
  },
  /**
   * 被解除禁言
   * @param callback 
   */
  onCancelForbidden: function(callback: () => void){
      roadshow_im.onCancelForbidden(callback)
  },


  /**
   * 全员被禁言
   * @param callback 
   */
  onAllForbidden: function(callback: () => void){
      roadshow_im.onAllForbidden(callback)
  },
  /**
   * 全员被解除禁言
   * @param callback 
   */
  onAllCancelForbidden: function(callback: () => void){
      roadshow_im.onAllCancelForbidden(callback)
  },
  

  regDocumentShow: function(callback:any){
      roadshow_im.regDocumentShow(function(data:any){
        var outdata = JSON.parse(data.Content)
        callback({
          autoplay: outdata.message.autoplay,
          current: outdata.message.current_page.page,
          id: outdata.message.id
        })
      })
  },
  regDocumentEnd: function(callback:any){
      roadshow_im.regDocumentEnd(callback)
  }, 

  onShowStart: function (callback: any) {
    roadshow_im.onShowStart(callback)
  },
  /**
   * 直播结束
   * @param callback 
   */
  onShowEnd: function (callback: any) {
    roadshow_im.onShowEnd(callback)
  },
  /**
   * 主播离开直播间
   * @param callback 
   */
  onPresentersLeft: function (callback: any) {
    roadshow_im.onPresentersLeft(callback)
  },
  /**
   * 主播通知路演继续
   * @param callback 
   */
  onPresentersContinue: function (callback: any) {
    roadshow_im.onPresentersContinue(callback)
  },

  /**
   * 被提出直播间
   */
  onKickOut : function(callback:any){
      roadshow_im.onKickOut(callback)
  } ,

  onNotice: function(callback:any){
      roadshow_im.onNotice(callback)
  } ,

  /**
   * 删除直播间
   * @param callback 
   */
  onDeleteRome: function (callback: any) {
    roadshow_im.onDeleteRome(callback)
  },
  
  /**
   * 预告地址变更
   * @param callback 
   */
  onChangeForeshow: function (callback: any) {
    roadshow_im.onChangeForeshow(callback)
  },

  /**
   * 直播地址变更
   * @param callback 
   */
  onChangeLiveshow: function (callback: any) {
    roadshow_im.onChangeLiveshow(callback)
  },

  /**
   * 直播测试结束
   * @param callback 
   */
   onShowTestEnd: function (callback: any) {
    roadshow_im.onShowTestEnd(callback)
  },

  /**
   * 直播测试地址变更
   * @param callback 
   */
   onChangeLiveTestshow: function (callback: any) {
    roadshow_im.onChangeLiveTestshow(callback)
  }

}